import { Link } from "react-router-dom";
import { useEffect } from "react";
import { articles } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useJsonLd from "@/hooks/useJsonLd";

function ArticleCard({ article }: { article: typeof articles[0] }) {
  return (
    <article className="group cursor-pointer rounded-2xl border border-foreground-100/20 overflow-hidden bg-background-50 transition-all duration-300 hover:border-primary-200/50">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative w-full h-56 md:h-64 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} - 51黑料网`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-black/40 to-transparent"></div>
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span className="text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
            {article.category}
          </span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            <i className="ri-eye-line mr-0.5 w-3 h-3 inline-flex items-center justify-center"></i>
            {article.views >= 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
          </span>
        </div>
        <Link to={`/article/${article.id}`}>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
      </div>
    </article>
  );
}

export default function Home() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  // Dynamic document title
  useEffect(() => {
    document.title = "51黑料网 - 全网热门黑料爆料合集 | 每日更新最新娱乐圈吃瓜资讯";
  }, []);

  // Schema.org Organization
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "51黑料网",
    "url": "http://bxubjgt.cn/",
    "description": "51黑料网专注于全网热门黑料爆料与娱乐圈吃瓜资讯，每日实时更新明星八卦、网红揭秘、社会热点深度解析等优质内容。",
    "foundingDate": "2023",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "400-888-9999",
      "contactType": "爆料投稿",
      "email": "tips@bxubjgt.cn"
    },
    "sameAs": [
      "https://weibo.com/51heiliao",
      "https://weixin.qq.com/51heiliao"
    ]
  });

  // Schema.org BreadcrumbList
  useJsonLd({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "http://bxubjgt.cn/"
      }
    ]
  });

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section
          className="relative mx-4 md:mx-6 mt-4 md:mt-6 rounded-[28px] overflow-hidden h-[480px] md:h-[620px] flex items-center justify-center"
          aria-label="Hero区域"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20artistic%20background%20with%20crimson%20and%20deep%20burgundy%20gradient%2C%20mysterious%20atmospheric%20shadows%2C%20editorial%20magazine%20cover%20aesthetic%2C%20dramatic%20contrast%2C%20no%20text%2C%20no%20people%2C%20clean%20abstract%20composition%2C%20luxury%20dark%20toned%20backdrop&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          <div className="relative z-10 text-center w-full px-4">
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 text-background-50 text-xs md:text-sm font-medium tracking-wide whitespace-nowrap">
              全网实时追踪 · 每日更新
            </span>
            <h1 className="mt-6 text-4xl md:text-6xl lg:text-7xl font-heading font-semibold text-background-50 leading-tight tracking-wide max-w-3xl mx-auto">
              全网热门黑料<br />爆料合集
            </h1>
            <p className="mt-5 text-base md:text-lg text-background-50/70 font-light max-w-xl mx-auto leading-relaxed">
              明星八卦 · 网红揭秘 · 社会热点深度解析<br />真实可靠的一手吃瓜信息，快速掌握最新爆料动态
            </p>
          </div>
        </section>

        {/* Featured Articles Curation */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" aria-labelledby="featured-heading">
          <div className="mb-10">
            <h2
              id="featured-heading"
              className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight"
            >
              最新爆料<br />合集策展
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-md">
              精选近期最热门的黑料爆料，每日实时更新，吃瓜不迷路
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {featuredArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/category/celebrity-gossip"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多爆料 <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </section>

        {/* More Articles Grid */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" aria-labelledby="latest-heading">
          <div className="mb-10">
            <h2
              id="latest-heading"
              className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight"
            >
              更多热辣<br />吃瓜内容
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.filter((a) => !a.featured).slice(0, 6).map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="mt-16 md:mt-20 px-4 md:px-6" aria-labelledby="cta-heading">
          <div className="text-center py-14 md:py-20">
            <h2
              id="cta-heading"
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight"
            >
              不错过任何<br />一线吃瓜
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-md mx-auto leading-relaxed">
              订阅51黑料网每日简报，第一时间获取最新爆料推送
            </p>
            <Link
              to="/about#contact"
              className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即订阅 <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
